module.exports = __webpack_public_path__ + "static/media/S2N2-2.e3089cea.svg";